import React from "react";

export default function ExpenseTab({ formData, onChange, disabled }) {
  return (
    <div className="role-tab">
      {/* Enable Expense */}
      <div className="role-tab__header">
        <h3 className="role-tab__title">Expense Configuration</h3>
        <label className="role-form__checkbox-label role-form__checkbox-label--large">
          <input
            type="checkbox"
            checked={formData.enableExpense}
            onChange={(e) => onChange("enableExpense", e.target.checked)}
            disabled={disabled}
          />
          <span>Enable Expense</span>
        </label>
      </div>

      <div className="role-tab__content">
        {/* Content area ready for future expense configuration options */}
      </div>
    </div>
  );
}
